import React from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import client from '../lib/apolloClient';
import configureStore from '../store/findBobPublicStore';
import { SnackbarProvider } from 'notistack';
import getMessages from '../lib/i18n/getMessages';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import SuccessionDrawerWithListener from './Succession/SuccessionDrawerWithListener';
import PactBuilder from '../components/Succession/PactBuilder';

const PactBuilderContainer = (props, railsContext) => {
  const mergedCompany = props.company
    ? { ...props.company, feature_types: (props.company.feature_types || props.features || []), features: (props.company.features || props.features || []) }
    : {
      host: railsContext && railsContext.company_host,
      features: (railsContext && railsContext.features) || [],
      name: railsContext && railsContext.company_name,
      branded_name: railsContext && railsContext.company_branded_name,
    };

  const initialState = {
    company: mergedCompany,
    user: props.current_user,
    intl: { locale: (railsContext && railsContext.i18nLocale) || 'en' },
  };

  const store = configureStore(initialState);
  if (typeof document !== 'undefined') {
    document.store = store;
  }
  const locale = (typeof window !== 'undefined' && window.locale) || (railsContext && railsContext.i18nLocale) || 'en';

  return (
    <Provider store={store}>
      <ApolloProvider client={client}>
        <SnackbarProvider maxSnack={3}>
          <IntlProvider locale={locale} messages={getMessages(locale)}>
            <SuccessionThemeProvider company={mergedCompany} user={props.current_user}>
              <PactBuilder {...props} />
              <SuccessionDrawerWithListener />
            </SuccessionThemeProvider>
          </IntlProvider>
        </SnackbarProvider>
      </ApolloProvider>
    </Provider>
  );
};

export default PactBuilderContainer;
